module.exports = __webpack_public_path__ + "static/media/add supplier.cfd998af.svg";